<div class="tabs-wrapper d-flex align-items-center justify-content-between"
     [ngClass]="[tabCssClass || '','nav-tabs-sticky']">
  <div class="flex-grow-1 h-100">
    <ul ngbNav #nav="ngbNav" class="nav-underline h-100" [ngClass]="{
        'is-admin': reduceHorizontalSpacing,
        'justify-content-center': areTabsCentered
      }" [class.mb-3]="reduceHorizontalSpacing" [(activeId)]="active" (navChange)="onNavChange($event)">
      @for (tab of tabs;track tab) {
        <ng-container>
          <li [ngbNavItem]="tab.itemId" class="d-flex">
            <a ngbNavLink class="d-flex align-items-center">
              <div class="fs-14-16 px-2 px-xl-0 fw-normal d-flex align-items-center">
                {{tab.title}}
                @if (tab.showIndicator) {
                  <ng-container>
                    <div class="indicator-box">
                      <app-checkmark-indicator [isChecked]="tab.isChecked"/>
                    </div>
                  </ng-container>
                }
              </div>
            </a>
            <ng-template ngbNavContent>
              <ng-container *ngTemplateOutlet="tab.content"/>
            </ng-template>
          </li>
        </ng-container>
      }
    </ul>
  </div>
  <ng-content/>
</div>

<div [ngbNavOutlet]="nav"></div>
